import { all } from "redux-saga/effects";
import cars from "./cars";
import loading from "./loading";
import sequence from "./sequence";

export default function* rootSaga() {
  yield all([cars(), loading(), sequence()]);
}
